import { disassociateEntity } from '../actions/disassociate-entity.js'
import { testXeroConnection } from '../actions/test-token.js'

export function addListeners (containerElement, browserAppAccount) {
  containerElement.addEventListener('click', async (clickEvent) => {
    const buttonElement = clickEvent.target.closest('button')
    if (!buttonElement) return

    buttonElement.classList.add('is-loading')

    const buttonAction = buttonElement.getAttribute('data-action')
    if (!buttonAction) return

    await handleButtonAction(buttonAction, buttonElement, browserAppAccount)

    buttonElement.classList.remove('is-loading')
  })
}

async function handleButtonAction (buttonAction, buttonElement, browserAppAccount) {
  if (buttonAction === 'disassociate') {
    const entityId = buttonElement.getAttribute('data-entity-id')
    if (!entityId) return

    const appAccountId = browserAppAccount.data.appAccountId

    console.log('clicked entityId', entityId)
    await disassociateEntity(appAccountId, entityId)
    await browserAppAccount.refreshEntities()
    document.dispatchEvent(new Event('cDisassociatedTenant'))
    console.log('cDisassociatedTenant emitted')
  }

  if (buttonAction === 'test-xero-connection') {
    const entityId = buttonElement.getAttribute('data-entity-id')
    if (!entityId) return

    console.log('clicked entityId', entityId)
    await testXeroConnection(entityId)
  }
}
